"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIN_TIMEOUT = exports.MIN_TIME_DELAY = exports.MAX_TIME_DELAY = exports.BC_ALERT_CONTENT = exports.BC_ALERT_INLINE = exports.BC_ALERT_DISMISSIBLE = exports.BC_ALERT_CLOSING = exports.BC_ALERT_CLOSE = exports.BC_ALERT_ACTIVE = exports.BC_ALERT = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
exports.BC_ALERT = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-alert");
exports.BC_ALERT_ACTIVE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-alert-active");
exports.BC_ALERT_CLOSE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-alert-close");
exports.BC_ALERT_CLOSING = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-alert-closing");
exports.BC_ALERT_DISMISSIBLE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-alert-dismissible");
exports.BC_ALERT_INLINE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-alert-inline");
exports.BC_ALERT_CONTENT = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-alert-content");
exports.MAX_TIME_DELAY = 10000;
exports.MIN_TIME_DELAY = 5000;
exports.MIN_TIMEOUT = 1000;
